import React, { useContext, useEffect, useState } from "react";

const DomiciliosItem = ({currentRow,setCurrentRow}) => {
  return (
    <div className="DomiciliosItem__container">
      <div>
        <h1>
          Domilicio <span>{currentRow.Tipo==1?"Acreditado":"Aval"}</span>
        </h1>
        <h2>
          Dirección: {currentRow.Domicilio}<br/>
          Localidad: {`${currentRow.Estado}, ${currentRow.Ciudad}`}
        </h2>
        <h2>C.P. {currentRow.Codpos} TEL.{currentRow.Tel}</h2>
      </div>
      <div>
        <button className="btnReportarObsoleto__domicilios" onClick={()=>setCurrentRow(currentRow)}>
          Ver
        </button>
      </div>
    </div>
  );
};

export default DomiciliosItem;
